import React, { useState, useEffect, useCallback } from "react";
import ClockDisplay from "./components/ClockDisplay/ClockDisplay";
import FeedbackDisplay from "./components/FeedbackDisplay/FeedbackDisplay";
import getRandomPosition from "./utils/positions";
import Tabs from "./components/Tabs";

import "./App.css";


function App() {
  return (
    <div className="app-container">
      <Tabs />
    </div>
  );
}

export default App;
